import DE_CONTACT_US_PAGE_CONSTANTS from './de'
import EN_CONTACT_US_PAGE_CONSTANTS from './en'
import FR_CONTACT_US_PAGE_CONSTANTS from './fr'
import HU_CONTACT_US_PAGE_CONSTANTS from './hu'
import { T_CONTACT_US_PAGE_CONSTANTS } from './TYPES'

import { T_GENERIC_LANGUAGE_MAP } from '~/src/Constants/LANGUAGE'

import objectPathFactory from '~/src/Lib/objectPathFactory'

const CONTACT_US_PAGE_CONSTANTS: T_GENERIC_LANGUAGE_MAP<T_CONTACT_US_PAGE_CONSTANTS> =
  {
    hu: HU_CONTACT_US_PAGE_CONSTANTS,
    en: EN_CONTACT_US_PAGE_CONSTANTS,
    fr: FR_CONTACT_US_PAGE_CONSTANTS,
    de: DE_CONTACT_US_PAGE_CONSTANTS
  }

export default CONTACT_US_PAGE_CONSTANTS

export const CONTACT_US_PAGE_CONSTANTS_PATH =
  objectPathFactory<T_CONTACT_US_PAGE_CONSTANTS>()
